import styled from 'styled-components';
import { Platform, DeviceType, Orientation } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export const ProductViewWrapper = styled.div<{
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
	nrPerRow: number;
}>`
	display: flex;
	flex-wrap: wrap;
	height: ${(props) => (props.platform === 'kiosk' ? 'calc(100vh - 164px)' : 'auto')};
	margin: ${(props) => (props.platform === 'kiosk' ? '0 60px' : '0')};

	.productViewItem {
		width: ${(props) =>
			props.platform === 'kiosk'
				? 'calc(25% - 30px)'
				: props.deviceType === 'mobile'
				? props.orientation === 'portrait'
					? 'calc(100% - 30px)'
					: 'calc(50% - 30px)'
				: props.deviceType === 'tablet'
				? 'calc(33% - 30px)'
				: 'calc(25% - 30px)'};
		&:nth-child(n + ${(props) => props.nrPerRow + 1}) {
			border-top: 1px solid ${SkapaTheme.color.border.light};
		}
		padding: 30px 15px 40px 15px;

		.card {
			height: 100%;
			width: ${(props) => (props.platform === 'kiosk' ? 'calc(100% - 50px)' : '100%')};
		}

		.card__image-aspect-ratio {
			height: auto;
		}

		.aspect-ratio-box[class*='--wide'] {
			padding-bottom: 65%;
		}
	}

	[data-element-name='kompis-product-card'] {
		width: ${(props) => (props.platform === 'kiosk' ? 'calc(100% - 50px)' : '100%')};
	}
`;
